const defaultThemeValues = {
    components: {
        Layout: {
            footerPadding: '4px 50px',
            headerPadding: '0 10px',
        },
    },
};

export default defaultThemeValues;
